"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingReportsService = void 0;
class ReportingReportsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns a list of reports.
     * @param page 'Page number (default 1)
     * @param count Number of results per page (default 10)
     * @param q Query to filter the results on
     * @returns ReportResponse
     * @throws ApiError
     */
    getReports(page, count, q) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/reports',
            query: {
                'page': page,
                'count': count,
                'q': q,
            },
        });
    }
    /**
     * Save a report.
     * @param requestBody
     * @returns ReportResponse
     * @throws ApiError
     */
    saveReport(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/reports',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns specific report details by id.
     * @param id Identifier (uuid format)
     * @returns ReportResponse
     * @throws ApiError
     */
    getReport(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/reports/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update a report.
     * @param id Identifier (uuid format)
     * @param requestBody
     * @returns ReportResponse
     * @throws ApiError
     */
    updateReport(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/reports/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a report.
     * @param id Identifier (uuid format)
     * @returns any Successful response
     * @throws ApiError
     */
    deleteReport(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/reports/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Returns a list of report fields.
     * @returns ReportingFieldReponse
     * @throws ApiError
     */
    getReportFields() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/reporting/fields',
        });
    }
    /**
     * Returns an enum.
     * @param enumName
     * @returns ReportingEnumReponse
     * @throws ApiError
     */
    getReportEnums(enumName) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/reporting/enums/{enumName}',
            path: {
                'enumName': enumName,
            },
        });
    }
    /**
     * Returns a list of field operators.
     * @returns ReportFieldOperator
     * @throws ApiError
     */
    getReportFieldOperators() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/reporting/field-operators',
        });
    }
    /**
     * Run a report query.
     * @param requestBody
     * @returns ReportResults
     * @throws ApiError
     */
    postReportQuery(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/reporting/query',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Run a report summary query.
     * @param requestBody
     * @returns ReportResultsSummary
     * @throws ApiError
     */
    postReportSummaryQuery(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/reporting/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.ReportingReportsService = ReportingReportsService;
